import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList } from '../../models/.catalog';

export default class RaporUrlGetirApi extends ApiBase<pList, string> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/GetirRaporURL',
      }),
      options
    );
    this._ServiceUrl = '/services/SistemAyarlar.asmx';
  }
}
